import React from "react";
type Props = {
    sectionName: string;
  };
  
  const ErrorFallback = ({ sectionName }: Props) => {
    return (
      <div className={`text-center`}>
        <h4 className="font-Cls f-sm-s22 f-s24 text-start h-24 medium_text mb-4">
          {sectionName}
        </h4>
        <h1 className="h-24 font-Cls medium_text" style={{color: 'red'}}>
          Something went wrong. <br /> Kindly! refresh your page. 
        </h1><br/>
          <a
            className="btn-large w-25 mx-auto text-capitalize"
            onClick={() => {
              window.location.reload();
            }}
          >
            Refresh Page
          </a>
        <hr/>
      </div>
    )
  }
  
  export default ErrorFallback;